import * as Types from '../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InvoicesQueryVariables = Types.Exact<{
  patientUuid: Types.Scalars['String'];
}>;


export type InvoicesQuery = { readonly __typename?: 'Query', readonly invoices: ReadonlyArray<{ readonly __typename?: 'Invoice', readonly _id: string, readonly created: string, readonly invoiceNumber: string, readonly invoiceStatus: Types.InvoiceStatus, readonly patientType: Types.PatientType, readonly createdBy: { readonly __typename?: 'InvoiceUser', readonly uuid?: string | null, readonly person?: { readonly __typename?: 'InvoicePersonName', readonly firstname?: string | null, readonly lastname?: string | null } | null }, readonly payers: ReadonlyArray<{ readonly __typename?: 'Payer', readonly type: Types.PayerType, readonly balance: { readonly __typename?: 'Balance', readonly paid?: number | null } }>, readonly balance: { readonly __typename?: 'Balance', readonly total?: number | null, readonly paid?: number | null, readonly due?: number | null, readonly currency?: Types.BillingCurrency | null }, readonly facility: { readonly __typename?: 'InvoiceClinic', readonly name: string, readonly uuid: string }, readonly organisation: { readonly __typename?: 'InvoiceOrganisation', readonly uuid: string, readonly name: string } }> };


export const InvoicesDocument = gql`
    query invoices($patientUuid: String!) {
  invoices(patientUuid: $patientUuid) {
    _id
    created
    invoiceNumber
    invoiceStatus
    patientType
    createdBy {
      person {
        firstname
        lastname
      }
      uuid
    }
    payers {
      type
      balance {
        paid
      }
    }
    balance {
      total
      paid
      due
      currency
    }
    facility {
      name
      uuid
    }
    organisation {
      uuid
      name
    }
  }
}
    `;

/**
 * __useInvoicesQuery__
 *
 * To run a query within a React component, call `useInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoicesQuery({
 *   variables: {
 *      patientUuid: // value for 'patientUuid'
 *   },
 * });
 */
export function useInvoicesQuery(baseOptions: Apollo.QueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
      }
export function useInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoicesQuery, InvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoicesQuery, InvoicesQueryVariables>(InvoicesDocument, options);
        }
export type InvoicesQueryHookResult = ReturnType<typeof useInvoicesQuery>;
export type InvoicesLazyQueryHookResult = ReturnType<typeof useInvoicesLazyQuery>;
export type InvoicesQueryResult = Apollo.QueryResult<InvoicesQuery, InvoicesQueryVariables>;